module.exports = __webpack_public_path__ + "img/logo_login.58226ed8.png";